<template>
  <v-dialog v-model="isVisible" max-width="600px" persistent>
    <v-card class="cb-card">
      <card-title title="Enviar semillas" />

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p>
                Se van a enviar las siguientes semillas al dominio 
                <strong>{{ targetDomain }}</strong>:
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="pa-2 cb-row-bordered seeds-list">
                <v-checkbox
                  v-for="(seed, index) in availableSeeds"
                  :key="index"
                  v-model="selectedSeeds"
                  :label="seed"
                  :value="seed"
                  class="mt-1"
                  dense
                  hide-details
                />
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12">
              <v-row>
                <v-text-field
                  v-model="newSeed"
                  class="mr-2"
                  dense
                  hide-details
                  outlined
                  placeholder="Añadir nuevo dominio"
                  @keyup.enter="addNewSeed"
                />

                <button-icon-text-model-b
                  :disabled="!canAddSeed"
                  icon="add"
                  text="Añadir"
                  @click="addNewSeed"
                />
              </v-row>
            </v-col>
          </v-row>

          <v-row v-if="selectedSeeds.length > 0" class="mt-2">
            <v-col cols="12">
              <v-chip class="mr-2" label small>
                <strong>{{ selectedSeeds.length }}</strong>&nbsp;semilla(s) seleccionada(s)
              </v-chip>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="cb-row-contrast_low pa-4">
        <v-row justify="space-between">
          <button-icon-text-model-b
            color="error"
            text="Cancelar"
            @click="handleCancel"
          />

          <button-icon-text-model-b
            :disabled="selectedSeeds.length === 0"
            color="primary"
            text="Enviar semillas"
            @click="handleSend"
          />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonIconTextModelB from "@/components/repository/buttons/ButtonIconTextModelB.vue";
import CardTitle from "@/components/repository/cards/CardTitle.vue";

export default {
  name: "SendSeedsDialog",
  components: {
    ButtonIconTextModelB,
    CardTitle
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    targetDomain: {
      type: String,
      default: ""
    },
    seeds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      availableSeeds: [...this.seeds],
      selectedSeeds: [...this.seeds],
      newSeed: ""
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    canAddSeed() {
      return this.newSeed && this.newSeed.trim() !== '';
    }
  },
  watch: {
    seeds(val) {
      this.availableSeeds = [...val];
      this.selectedSeeds = [...val];
    }
  },
  methods: {
    addNewSeed() {
      const trimmedSeed = this.newSeed.trim();

      if (trimmedSeed && !this.availableSeeds.includes(trimmedSeed)) {
        this.availableSeeds.push(trimmedSeed);
        this.selectedSeeds.push(trimmedSeed);
        this.newSeed = "";
      }
    },
    handleCancel() {
      this.resetDialog();
      this.$emit('cancel');
    },
    handleSend() {
      if (this.selectedSeeds.length === 0) return;

      this.$emit('send', this.selectedSeeds);
      this.resetDialog();
    },
    resetDialog() {
      this.availableSeeds = [];
      this.selectedSeeds = [];
      this.newSeed = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.seeds-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>
